exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-page-organization-photos[data-v-46e688ed]{position:relative}.component-page-organization-photos_height[data-v-46e688ed]{height:460px}@media only screen and (min-width:64.063em){.component-page-organization-photos_height[data-v-46e688ed]{height:460px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46e688ed","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/organization/photos/component.vue
// module id = ae643ae0bfe45beb1422
// module chunks = 1